function i(o, e) {
  return (o % e + e) % e;
}
function n(o) {
  if (typeof window.devicePixelRatio != "number") return Math.round(o);
  const e = window.devicePixelRatio;
  return Math.floor(o * e + 0.5) / e;
}
export {
  n as roundToDevicePixel,
  i as wrap
};
